import { reject } from 'lodash'
import {
  IShipmentStopTypes,
  IShipperRateShipperFacilityInput,
  IUpdateShipperRateInput,
} from 'types/graphqlTypes'
import { IAwardedLaneFragment } from 'apps/marketplace/pages/awarded-lanes/graphql/AwardedLaneFragment'
import { TLaneDetailsSchema } from '../schema/LaneDetailsSchema'

export const parseFormInput = (
  awardedLane: IAwardedLaneFragment,
  input: TLaneDetailsSchema
): IUpdateShipperRateInput => {
  const {
    commodity,
    deliveryFacility,
    maxWeight,
    minWeight,
    note,
    offerLeadTime,
    pickupFacility,
  } = input

  const shipperRateShipperFacilitiesToAdd: IShipperRateShipperFacilityInput[] = []

  if (pickupFacility?.id) {
    shipperRateShipperFacilitiesToAdd.push({
      shipperFacilityUuid: pickupFacility.id,
      stopType: IShipmentStopTypes.pickup,
    })
  }

  if (deliveryFacility?.id) {
    shipperRateShipperFacilitiesToAdd.push({
      shipperFacilityUuid: deliveryFacility.id,
      stopType: IShipmentStopTypes.delivery,
    })
  }

  /**
   * @description Remove all existing shipper_rate_shipper_facilities that don't match either of the two facilities
   * entered in the form.
   */
  const shipperRateShipperFacilitiesToRemove = reject(
    awardedLane.shipperRateShipperFacilities,
    srsf => {
      if (srsf.stopType === IShipmentStopTypes.pickup) {
        return srsf.shipperFacility.uuid === pickupFacility?.id
      }

      return srsf.shipperFacility.uuid === deliveryFacility?.id
    }
  ).map(srsf => srsf.id)

  return {
    id: awardedLane.id,
    listingDetails: {
      commodity,
      minWeight,
      maxWeight,
      note,
      offerLeadTime,
    },
    addShipperRateShipperFacilities: shipperRateShipperFacilitiesToAdd,
    removeShipperRateShipperFacilities: shipperRateShipperFacilitiesToRemove,
  }
}
